import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, map, ReplaySubject } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Md5 } from 'ts-md5';
import { CustomTranslateService } from '@app/apps/dlr-monitor/services/custom-translate.service';


@Pipe({
  name: 'translateText',
  pure: false
})

export class TranslateTextPipe implements PipeTransform {
  private translations: any[] = [];
  translationMap: { [hash: string]: any } = {};
  constructor(private translateService: CustomTranslateService) {
    this.translations = this.translateService.translateJSONFromFile;
    for (const item of this.translateService.translateJSONFromFile) {
      this.translationMap[item.orginal_text_hash] = item;
    }
  }

  transform(text: string, lang?: string): Observable<string> {
    return this.translateService.language$.pipe(
      map(updt_lng => {
        // Basic validation
        if (!text || text.trim() === '') {
          return text;
        }
        return this.getTranslation(text, updt_lng);
      })
    );
  }


  private getTranslation(text: string, lang: string): string {
    if (lang === 'tel') {
      // Early return for performance if text is empty
      if (!text || text.trim() === '') {
        return text;
      }
      text = text.trim();
      // Compute hash once for the input text
      const textHash = Md5.hashStr(text.toLowerCase());

      // Use direct lookup with a pre-computed hash rather than find()
      // Convert to a for loop with early termination for better performance
      if(this.translations.length == 0){
        this.translations = this.translateService.translateJSONFromFile;
        for (const item of this.translateService.translateJSONFromFile) {
          this.translationMap[item.orginal_text_hash] = item;
        }
      }
      // let entry = null;
      const entry = this.translationMap[textHash] || null;
      // for (let i = 0; i < this.translations.length; i++) {
      //   const item = this.translations[i];
      //   if (textHash === item.orginal_text_hash) {
      //     entry = item;
      //     break; // Stop searching once found
      //   }
      // }

      if (!entry) {
        this.translateService.addNewTranslation(text);
        return text;
      }

      return entry.tel_tr_text || entry.eng_tr_text || text;
    } else {
      return text;
    }
  }

}
